module.exports = __webpack_public_path__ + "static/media/02n.b08c6f2c.png";